import React from "react";

/**
 * Bloc de présentation pour la section réalisations web
 */
const RealisationsWebPresentation = () => (
  <>
    <p>
      Vous trouvez ici quelques projets web que j&apos;ai réalisés seule ou en
      équipe, utilisant différentes technologies comme React, VueJS, NodeJs ou
      Symfony.
    </p>
    <p>
      Tous les sites et applications que je crée respectent les normes W3C,
      respectent le référencement naturel (SEO) et sont responsives, adaptables
      sur toutes les interfaces (mobiles, tablettes et ordinateurs).
    </p>
  </>
);

export default RealisationsWebPresentation;
